import React, {useState} from 'react';

export type ScreenTypes = 'users' | 'roles' | 'groups';

type ID = string;

interface BaseNode {
  id: ID;
  name: string;
  icon: string;
}

export interface BranchData extends BaseNode {
  isClient: false;
  clientId: ID;
  branches: BranchData[]; // allow nested branches; use [] if none
}

export interface ClientDataType extends BaseNode {
  isClient: true;
  branches: BranchData[]; // top-level client has branches
}

// Optional: a union to treat both uniformly
export type ClientTreeNode = ClientDataType | BranchData;

interface UsersScreenContextType {
  // General

  selectedScreen: ScreenTypes;
  setSelectedScreen: React.Dispatch<React.SetStateAction<ScreenTypes>>;
  searchText: string;
  setSearchText: React.Dispatch<React.SetStateAction<string>>;
}

const UsersScreenContext = React.createContext<UsersScreenContextType | null>(
  null,
);

type Props = {
  children: React.ReactNode;
};

function UsersScreenContextProvider({children}: Props) {
  // General

  const [selectedScreen, setSelectedScreen] = useState<ScreenTypes>('users');
  const [searchText, setSearchText] = useState('');

  return (
    <UsersScreenContext.Provider
      value={{
        selectedScreen,
        setSelectedScreen,
        searchText,
        setSearchText,
      }}>
      {children}
    </UsersScreenContext.Provider>
  );
}

export default UsersScreenContextProvider;

export const useUsersScreenContext = () => {
  const context = React.useContext(UsersScreenContext);
  if (context === null) {
    throw new Error(
      'useUsersContext must be used within an UsersScreenContextProvider',
    );
  }
  return context;
};
